import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class ExistsSameOrderResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "order_numbers": [
                    "00-449384234",
                    "01-499384234"
                ],
                "exists": "false"
            },
            errors: []
        }
    }

    existsSameOrder() {
        return this.content().exists;
    }

    orderNumbers(){
        return this.content().order_numbers;
    }
}